import type { Board } from 'chessboard/model/board/types';

/**
 * Get the asset base path.
 */
export function getAssetBasePath(option?: Board.Options): string {
  const basePath = option?.assetPaths?.basePath;
  return basePath || 'https://www.chess.com';
}
